import { ControlValueAccessor } from '@angular/forms';

export class BaseControlValueAccessor<T> implements ControlValueAccessor {
    public disabled = false;

    /**
   * Call when value has changed programmatically
   */
    public value: T[];
    public onChange(newVal: T[]) {}
    public onTouched(_?: any) {}

    /**
   * Model -> View changes
   */
    public writeValue(objects: T[]): void {
        this.value = objects;
    }
    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    public setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
